<kendo-dialog [title]="titleLabel | localizeLabel" (close)="close()" [width]="680" class="vo-modal" *ngIf="opened">
  <div class="vo-body-regular-14" [innerHtml]="referenceDataLabels.PrivacyNoticeMessage | localizeLabel"></div>

  <div class="d-flex align-items-center justify-content-center mt-30">
    <span
      class="vo-link"
      [innerHTML]="referenceDataLabels.GDPRPrivacyNotice | localizeLabel"
      (click)="openGdprDialog.emit(true)"
    ></span>
  </div>

  <kendo-dialog-actions class="d-flex justify-content-between align-items-center">
    <button
      class="vo-secondary-button-1"
      [innerHtml]="referenceDataLabels.PrivacyDecline | localizeLabel"
      (click)="declinePrivacyNotice()"
    ></button>
    <button
      class="vo-primary-button-1"
      [innerHtml]="referenceDataLabels.PrivacyConfirm | localizeLabel"
      (click)="acceptPrivacyNotice()"
    ></button>
  </kendo-dialog-actions>
</kendo-dialog>
